import React from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { appErrorSelector } from '@redux/slices/workflowSlice'
import { Button } from '@components/ui-css/Button'
import { useInteractionContext } from '@components/interactionContext/useInteractionContext'
import { useEnvironment } from '@hooks/useEnvironment'

export const RetryButton: React.FC = () => {
  const { translationNamespace } = useEnvironment()
  const { t } = useTranslation(translationNamespace, { keyPrefix: 'ErrorPage' })
  const error = useSelector(appErrorSelector)
  const { pushFallbackInteraction } = useInteractionContext()

  if (typeof error?.retryCallback !== 'function') {
    return null
  }

  const onClick = () => {
    pushFallbackInteraction('retry')
    error?.retryCallback?.()
  }

  return <Button onClick={onClick}>{t('body.retryLabel')}</Button>
}
